export function assetUrl(route: string) {
  return new URL(String(`src/assets/${route}`).replace(/\/\//g, '/'), window.location.origin).href
}

let scrollLockCount = 0

export function lockScroll() {
  scrollLockCount++
  if (scrollLockCount === 1) {
    // Compensar el ancho del scrollbar para evitar salto de layout
    const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth
    if (scrollBarWidth > 0) {
      document.body.style.paddingRight = `${scrollBarWidth}px`
    }

    // Bloquear scroll sin mover el body — el contenido queda en su posición
    document.documentElement.style.overflow = 'hidden'
  }
}

export function unlockScroll() {
  scrollLockCount = Math.max(0, scrollLockCount - 1)
  if (scrollLockCount === 0) {
    document.body.style.paddingRight = ''
    document.documentElement.style.overflow = ''
  }
}
